import cn from 'classnames';
import { Layout, Localization, Typography } from 'connex-cds';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const { ShortDateTime, Translate } = Localization;
const { Subtitle } = Typography;

const Styled = styled(Layout.Container)``;

const LoadingPointMobile = ({ className, ticket, plantAddress, loadingStarted }) => (
  <Styled className={cn('loading-point', className)}>
    <Subtitle>
      <Translate stringId="loadingPoint" data-testid="loadingPointLabel" />
    </Subtitle>
    <div className="label">
      <Translate stringId="plantName" data-testid="plantNameLabel" />:{' '}
    </div>
    <span data-testid="plantNameValue">{ticket?.origin?.description}</span>
    <div className="label">
      <Translate stringId="plantAddress" data-testid="plantAddressLabel" />:{' '}
    </div>
    <span data-testid="plantAddressValue">{plantAddress}</span>
    <div className="label">
      <Translate stringId="loadingScheduleStart" data-testid="loadingScheduleStartLabel" />:{' '}
    </div>
    <span style={{ whiteSpace: 'nowrap' }} data-testid="loadingScheduleStart">
      <ShortDateTime date={loadingStarted} withDayOfWeek />
    </span>
  </Styled>
);

export default LoadingPointMobile;
